import { useAtom, useAtomValue } from 'jotai';
import { strings } from '@/i18n/i18n';
/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2023-08-30 10:07:24
 * @LastEditors: yusha
 * @LastEditTime: 2024-03-12 14:53:01
 * @FilePath: \ckb-smc-client-fed\src\hooks\useYan.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { User } from '@/model';
import { formatMoney } from '@/utils';
import { Site, countryCurrency } from '@/const/enum';
import { siteMapMonetaryUnit } from '@/const/enum/index';

/**
 * @param money 金额
 * @param isThousandth 是否需要千分位
 * @returns 返回货币及方向
 */
export function useGetActivePriceByStation(
    money: any,
    isThousandth = false
): string {
    const [stationCode] = useAtom(User.stationCode);

    let showText = '';
    // 是否千分位化
    const formarMoney = isThousandth ? formatMoney(money) : money;
    switch (stationCode) {
        case Site.JP:
            showText = formarMoney + ` ${siteMapMonetaryUnit.get(stationCode)}`;
            break;
        case Site.KR:
            showText = `${siteMapMonetaryUnit.get(stationCode)} ` + formarMoney;
            break;
        case Site.UK:
            showText = `${siteMapMonetaryUnit.get(stationCode)} ` + formarMoney;
            break;
    }
    return showText;
}

/** 单独获取站点的货币符号 */
export function useGetCountryCurrency() {
    const stationCode = useAtomValue(User.stationCode);
    return siteMapMonetaryUnit.get(stationCode);
}

/** 获取中国单位元 */
export function useGetChinaYuan() {
    const stationCode = useAtomValue(User.stationCode);
    if (stationCode === Site.JP) {
        return strings.t('(元)');
    }
    if (stationCode === Site.UK) {
        return '(CNY)';
    }
    return '(위안)';
}

/** 获取汇率文字 1元=汇率金额$ */
export function useGetExchangeText() {
    const yuan = useGetChinaYuan();
    const stationCode = useAtomValue(User.stationCode);
    const currency = countryCurrency.get(stationCode);
    const exchange = useAtomValue(User.exchangeRate);
    const isEN = stationCode === Site.JP;
    let value = 0;
    if (!isEN) {
        value = Math.floor(exchange * 100) / 100;
    } else {
        value = Math.round(exchange * 10000) / 10000;
    }

    if (stationCode === Site.UK) {
        return `CNY1=${currency}${Number(exchange).toFixed(4)}`;
    }

    return `CNY1=${currency} ${exchange}`;
}
